import { FormDefinition } from '../components/SchemaForm/SchemaForm.model'

export const formDefinition: FormDefinition = {
  formTitle: 'สั่งซื้อ Customize Wallpaper',
  formDescription: 'เพื่อการสั่งซื้อที่ครบถ้วนสมบูรณ์ กรุณาให้ข้อมูลเพิ่มเติม',
  summaryTitle: 'ยืนยันคำสั่งซื้อ Customize Wallpaper',
  numberOfPage: 2,
  defaultValues: {
    collection: 'chinese_god',
    allowNewsletter: 'false',
  },
  pageCardIndexOption: {
    1: {
      0: {
        cardTitle: 'ข้อมูลส่วนตัว',
      },
      1: {
        cardTitle: 'รายละเอียดการสั่งซื้อ',
      },
    },
  },
  summaryCardIndexOption: {
    1: {
      cardTitle: 'ข้อมูลคอลเลคชันวอลเปเปอร์',
    },
    2: {
      cardTitle: 'ข้อมูลส่วนตัว',
      backPageOption: {
        label: 'แก้ไขข้อมูล',
        toPageIndex: 1,
      },
    },
  },
  fields: [
    {
      type: 'readonlyInput',
      name: 'collection',
      pageIndex: 0,
      cardIndex: 0,
      title: 'คอลเลคชันวอลเปเปอร์ที่คุณลูกค้าสั่งซื้อ',
      properties: {
        readonlyInputValue: 'เทพเซียน Collection',
      },
    },
    {
      type: 'radio',
      required: true,
      name: 'template',
      pageIndex: 0,
      cardIndex: 1,
      title: 'องค์เทพที่ต้องการเลือก',
      description: '(เลือก 1 เรื่องเท่านั้น)',
      properties: {
        controlOptions: [
          {
            label: 'เทพเจ้าเห้งเจีย',
            value: 'wukong',
            modalData: {
              title: 'เทพเจ้าเห้งเจีย',
              content: `<p>ช่วยเสริมสติปัญญา ชนะศัตรู ต่อสู้อุปสรรค ผ่านได้ทุกปัญหา ปัดเป่าสิ่งชั่วร้าย มีชื่อเสียง ร่ำรวยเงินทอง มีโชคลาภ</p>
              <p><b>เหมาะกับ</b> - ค้าขายทอง เพชรพลอย เครื่องจักร รถยนต์ การขนส่ง งานที่มีการติดต่อระหว่างประเทศ ผู้บริหาร การเงิน การลงทุน ไฟแนนซ์ โรงรับจำนำ งานอุตสาหกรรม ไอที</p>`,
            },
          },
          {
            label: 'เจ้าแม่กวนอิม',
            value: 'guanim',
            modalData: {
              title: 'เจ้าแม่กวนอิม',
              content: `<p>เสริมให้ได้รับความเมตตา ขจัดปัดเป่าสิ่งไม่ดี ไม่มีโรคภัยไข้เจ็บ มีองค์ความรู้ ให้พบกับความสุขความสำเร็จ มีโชคลาภ มีบริวารดี สมหวังในความรัก</p>
              <p><b>เหมาะกับ</b> - ทำงานคาเฟ่ โรงแรม ทำทัวร์ แอร์โฮสเตส ฝ่ายบุคคล เซลล์ งานบันเทิง โซเชียลมีเดีย นักเขียน สำนักพิมพ์ อาจารย์ งานเฟอร์นิเจอร์ ขายดอกไม้ ทำการเกษตร</p>`,
            },
          },
          {
            label: 'เทพไฉ่ซิงเอี๊ย',
            value: 'god_of_wealth',
            modalData: {
              title: 'เทพไฉ่ซิงเอี๊ย',
              content: `<p>เสริมให้ค้าขายร่ำรวย เก็บเงินอยู่ ได้เปิดคลังทรัพย์ มีสมบัติจักรพรรดิ์ตักไม่พร่อง ลูกหนี้เกรงใจ มีอำนาจบารมี</p>
              <p><b>เหมาะกับ</b> - อสังหาริมทรัพย์ นายหน้า ขายที่ดิน ขายเครื่องประดับ บัญชี ผู้อำนวยการ ตัวแทนจำหน่าย ออแกไนซ์เซอร์ รักษาความปลอดภัย</p>`,
            },
          },
          {
            label: 'เทพกวนอู',
            value: 'guanyu',
            modalData: {
              title: 'เทพกวนอู',
              content: `<p>ช่วยเสริมลาภยศ อำนาจบารมี ให้สติปัญญาเป็นเลิศ มีชื่อเสียง ลูกน้องเกรงขาม ศัตรูเกรงใจ เป็นที่น่าเคารพยกย่อง มีมิตรภาพที่ดี</p>
              <p><b>เหมาะกับ</b> - นักแสดง นักร้อง นักพูด อินฟลู เอเจนซี่ งานโฆษณา ครีเอทีฟ ทำเกี่ยวกับความสวยความงาม เชฟ ทำงานปั๊มน้ำมัน เชื้อเพลิง ขายไฟฟ้า หลอดไฟ (เทพกวนอูเป็นธาตุไฟ จึงเสริมได้ดีกับคนที่ทำงานเกี่ยวกับความร้อนและไฟ)</p>`,
            },
          },
        ],
      },
    },
    {
      type: 'radio',
      required: true,
      name: 'choice',
      pageIndex: 0,
      cardIndex: 1,
      title: 'เรื่องที่ต้องการเสริม',
      description: '(เลือก 1 เรื่องเท่านั้น)',
      properties: {
        controlOptions: [
          { label: 'การเงิน', value: 'finance' },
          { label: 'การงาน', value: 'work' },
          { label: 'โชคลาภ', value: 'luck' },
          { label: 'การเรียน', value: 'study' },
        ],
      },
    },
    {
      type: 'radio',
      required: true,
      name: 'subChoice1',
      pageIndex: 0,
      cardIndex: 1,
      title: 'สิ่งที่ต้องการเสริม',
      description: '(เลือก 1 เรื่องเท่านั้น)',
      dependsOn: { choice: ['work'] },
      properties: {
        controlOptions: [
          { label: 'หางาน', value: 'seeking' },
          { label: 'มีงาน', value: 'working' },
          { label: 'ฟรีแลนซ์', value: 'freelancing' },
        ],
      },
    },
    {
      type: 'radio',
      required: true,
      name: 'subChoice2',
      pageIndex: 0,
      cardIndex: 1,
      title: 'สิ่งที่ต้องการเสริม (เพิ่มเติม)',
      description: '(เลือก 1 เรื่องเท่านั้น)',
      dependsOn: { choice: ['work'], subChoice1: ['seeking'] },
      properties: {
        controlOptions: [
          { label: 'ได้งานใหม่ที่ถูกใจ', value: 'good_job' },
          { label: 'งานอะไรก็ได้ที่เข้ามาไวๆ', value: 'quick_job' },
        ],
      },
    },
    {
      type: 'radio',
      required: true,
      name: 'subChoice2',
      pageIndex: 0,
      cardIndex: 1,
      title: 'สิ่งที่ต้องการเสริม (เพิ่มเติม)',
      description: '(เลือก 1 เรื่องเท่านั้น)',
      dependsOn: { choice: ['work'], subChoice1: ['working'] },
      properties: {
        controlOptions: [
          { label: 'งานราบรื่น ไม่มีอุปสรรค', value: 'smooth' },
          { label: 'งานประสบความสำเร็จ', value: 'success' },
          { label: 'เจ้านายเอ็นดู คนช่วยเหลืออุปถัมภ์', value: 'manager_support' },
          { label: 'สามารถปิดดีล เจรจาได้ลงตัว', value: 'close_deal' },
          { label: 'ได้เลื่อนขั้น เลื่อนตำแหน่ง', value: 'promotion' },
          { label: 'มีเสน่ห์ คนอยากติดตาม', value: 'charisma' },
        ],
      },
    },
    {
      type: 'radio',
      required: true,
      name: 'subChoice2',
      pageIndex: 0,
      cardIndex: 1,
      title: 'สิ่งที่ต้องการเสริม (เพิ่มเติม)',
      description: '(เลือก 1 เรื่องเท่านั้น)',
      dependsOn: { choice: ['work'], subChoice1: ['freelancing'] },
      properties: {
        controlOptions: [
          { label: 'มีงานเข้ามาเยอะๆ', value: 'more_work' },
          { label: 'ฝีมือดีขึ้น ไอเดียบรรเจิด', value: 'more_idea' },
          { label: 'ปิดดีล เจรจาลงตัว', value: 'fl_close_deal' },
        ],
      },
    },
    {
      type: 'radio',
      required: true,
      name: 'subChoice1',
      pageIndex: 0,
      cardIndex: 1,
      title: 'สิ่งที่ต้องการเสริม',
      description: '(เลือก 1 เรื่องเท่านั้น)',
      dependsOn: { choice: ['finance'] },
      properties: {
        controlOptions: [
          { label: 'มีเงินเข้ามาไม่ขาดมือ ', value: 'continuous' },
          { label: 'มีช่องทางการหาเงินใหม่ๆ', value: 'new_channel' },
          { label: 'มีคนมาอุปถัมภ์เรื่องการเงิน', value: 'fi_supporter' },
          { label: 'เก็บเงินอยู่', value: 'saving' },
        ],
      },
    },
    {
      type: 'radio',
      required: true,
      name: 'subChoice1',
      pageIndex: 0,
      cardIndex: 1,
      title: 'สิ่งที่ต้องการเสริม',
      description: '(เลือก 1 เรื่องเท่านั้น)',
      dependsOn: { choice: ['luck'] },
      properties: {
        controlOptions: [
          { label: 'มีโชคเรื่องการเงิน ', value: 'fortune' },
          { label: 'การเสี่ยงโชค', value: 'gamble' },
          { label: 'สุ่มของที่ต้องใช้โชค', value: 'gacha' },
        ],
      },
    },
    {
      type: 'radio',
      required: true,
      name: 'subChoice1',
      pageIndex: 0,
      cardIndex: 1,
      title: 'สิ่งที่ต้องการเสริม',
      description: '(เลือก 1 เรื่องเท่านั้น)',
      dependsOn: { choice: ['study'] },
      properties: {
        controlOptions: [
          { label: 'ได้คะแนนดี', value: 'good_score' },
          { label: 'มีสมาธิ ตั้งใจเรียน', value: 'concentration' },
          { label: 'สอบชิงทุน สอบเพื่อไปต่างประเทศ', value: 'inter_exam' },
          { label: 'สอบเข้ามหาลัยในประเทศ', value: 'dom_exam' },
          { label: 'ทำโปรเจกต์จบ', value: 'final_project' },
          { label: 'อาจารย์เอ็นดู คอยช่วยเหลือ', value: 'prof_supporter' },
        ],
      },
    },
    {
      type: 'radio',
      name: 'customCircle',
      pageIndex: 0,
      cardIndex: 2,
      title: 'บริการเสริม',
      hideTitleRequired: true,
      showSubtitleRequired: true,
      required: true,
      subtitle:
        'ใส่รูปพื้นหลังดวงจักรราศีของตัวเอง เพื่อช่วยให้วอลเปเปอร์เสริมพลังตัวเรามากขึ้น (เพิ่ม 50 บาท)',
      properties: {
        controlOptions: [
          { label: 'รับ', value: 'true' },
          { label: 'ไม่รับ', value: 'false' },
        ],
      },
    },
    {
      type: 'radio',
      name: 'startTimeUse',
      required: true,
      pageIndex: 0,
      cardIndex: 2,
      hideTitleRequired: true,
      showSubtitleRequired: true,
      subtitle:
        'บริการหาฤกษ์มงคลในการเริ่มใช้วอลเปเปอร์ (เพิ่ม 50 บาท) หากลูกค้าต้องการฤกษ์ใหม่ เนื่องจากใช้ตามฤกษ์ที่ให้ไว้ไม่ทันจะมีค่าบริการเพิ่มอีก 50 บาท',
      properties: {
        controlOptions: [
          { label: 'รับ', value: 'true' },
          { label: 'ไม่รับ', value: 'false' },
        ],
      },
    },
    {
      type: 'textInput',
      name: 'customerFirstname',
      required: true,
      pageIndex: 1,
      cardIndex: 0,
      label: 'ชื่อ',
      properties: {
        placeholder: 'กรุณากรอกชื่อ',
      },
    },
    {
      type: 'textInput',
      name: 'customerLastname',
      required: true,
      pageIndex: 1,
      cardIndex: 0,
      label: 'นามสกุล',
      properties: {
        placeholder: 'กรุณากรอกนามสกุล',
      },
    },
    {
      type: 'date',
      name: 'dateOfBirth',
      required: true,
      pageIndex: 1,
      cardIndex: 0,
      label: 'วันเกิด',
    },
    {
      type: 'time',
      name: 'timeOfBirth',
      required: true,
      pageIndex: 1,
      cardIndex: 0,
      label: 'เวลาเกิด',
      properties: {
        hasDisableTime: true,
        disableTimeCheckboxLabel: 'ไม่ทราบเวลาเกิด',
        defaultValueIfEmpty: '06:00',
      },
    },
    {
      type: 'select',
      required: true,
      name: 'gender',
      pageIndex: 1,
      cardIndex: 0,
      label: 'เพศ',
      properties: {
        controlOptions: [
          { label: 'ชาย', value: 'M' },
          { label: 'หญิง', value: 'F' },
          { label: 'LGBTQ+แนวหวาน', value: 'LGBTQ_F' },
          { label: 'LGBTQ+แนวแมน', value: 'LGBTQ_M' },
        ],
        placeholder: 'กรุณาเลือกเพศ',
      },
    },
    {
      type: 'textInput',
      name: 'genderText',
      pageIndex: 1,
      cardIndex: 0,
      dependsOn: { gender: ['LGBTQ_F', 'LGBTQ_M'] },
      properties: {
        numberOfLines: 2,
        placeholder: 'อธิบายเพิ่มเติม... (เช่น ฉันเป็นผู้ชายที่ชอบมองผู้ชาย ด้วยกัน)',
      },
    },
    {
      type: 'select',
      name: 'disease',
      label: 'คุณมีโรคประจำตัวตามนี้หรือไม่',
      footerText: '(บางโรคจะมีผลกับการที่แม่หมอจัดไพ่ จะได้ปรับหน้าไพ่ได้ดีขึ้น)',
      required: true,
      pageIndex: 1,
      cardIndex: 0,
      properties: {
        controlOptions: [
          { label: 'ไม่มี', value: 'healthy' },
          { label: 'ต่อมน้ำเหลือง ฮอร์โมน อ้วน', value: 'hormone' },
          { label: 'โรคกระเพาะ', value: 'digest' },
          { label: 'มะเร็ง ก้อนเนื้อ', value: 'cancer' },
          { label: 'ไมเกรน ปวดหัวบ่อย', value: 'migrane' },
          { label: 'ซีมเศร้า ไบโพลาร์', value: 'mental' },
        ],
        placeholder: 'กรุณาเลือกโรคประจำตัว',
      },
    },
    {
      type: 'tel',
      name: 'telephone',
      label: 'เบอร์โทรศัพท์',
      required: true,
      pageIndex: 1,
      cardIndex: 0,
      properties: {
        placeholder: 'กรุณากรอกเบอร์โทรศัพท์',
        textMaxLength: 12,
      },
    },
    {
      type: 'email',
      name: 'email',
      label: 'อีเมล์',
      footerText:
        '*ควรใส่เบอร์โทรศัพท์และอีเมล์ที่ใช้ประจำและสามารถติดต่อได้ เพื่อแจ้งเตือนการยืนยันการสั่งซื้อและการรับ Wallpaper',
      required: true,
      pageIndex: 1,
      cardIndex: 0,
      properties: {
        placeholder: 'กรุณากรอกอีเมล์',
      },
    },
    {
      type: 'textInput',
      name: 'remark',
      title: 'หมายเหตุ (ถ้ามี)',
      titleFontWeight: '400',
      description:
        'ไม่สามารถเลือกโทนสีได้ สามารถอธิบายในสิ่งที่อยากให้เสริม เพิ่มเติมได้ แต่ไม่สามารถเสริมเรื่องอื่นนอกจากสิ่งที่ลูกค้าเลือกมา เช่น เลือกเรื่องการเงิน แต่อยากให้เสริมความรักเพิ่ม เพราะไพ่จะไม่สามารถโฟกัสได้หลายอย่างในเวลาเดียวกัน',
      pageIndex: 1,
      cardIndex: 0,
      properties: {
        placeholder: 'โปรดระบุ...',
        numberOfLines: 5,
        textMaxLength: 150,
      },
    },
    {
      type: 'radio',
      name: 'saleChannel',
      label: 'ช่องทางการสั่งซื้อ',
      required: true,
      pageIndex: 1,
      cardIndex: 1,
      properties: {
        controlOptions: [
          { labelImageSrc: '/images/social-line.svg', value: 'line' },
          // [Todo]: Would be used later
          // { labelImageSrc: '/images/social-line-my-shop.svg', value: 'line_my_shop' },
          { labelImageSrc: '/images/social-facebook.svg', value: 'facebook' },
          { labelImageSrc: '/images/social-shopee.svg', value: 'shopee' },
        ],
      },
    },
    {
      type: 'textInput',
      name: 'saleUsername',
      required: true,
      pageIndex: 1,
      cardIndex: 1,
      dependsOn: { saleChannel: ['line', 'line_my_shop'] },
      properties: {
        placeholder: 'กรอกชื่อ Line ที่ติดต่อกับทางร้าน',
      },
    },
    {
      type: 'textInput',
      name: 'saleUsername',
      required: true,
      pageIndex: 1,
      cardIndex: 1,
      dependsOn: { saleChannel: ['facebook'] },
      properties: {
        placeholder: 'กรอกชื่อ Facebook ที่ติดต่อกับทางร้าน',
      },
    },
    {
      type: 'textInput',
      name: 'saleUsername',
      required: true,
      pageIndex: 1,
      cardIndex: 1,
      dependsOn: { saleChannel: ['shopee'] },
      properties: {
        placeholder: 'กรอก username ที่ติดต่อกับทางร้าน',
      },
    },
    {
      type: 'image',
      name: 'paySlip',
      title: 'สลิปที่โอนเงิน',
      description: 'กรุณาแนบสลิปที่โอนเงินเข้ามา',
      descriptionColor: '#000000',
      descriptionFontSize: '1rem',
      required: true,
      pageIndex: 1,
      cardIndex: 2,
    },
    {
      type: 'checkbox',
      label: 'รับข้อมูลข่าวสาร',
      hideFormLabel: true,
      name: 'allowNewsletter',
      pageIndex: 1,
      cardIndex: 3,
      properties: {
        checkboxLabel:
          'ฉันยินดีรับข้อมูลข่าวสาร (Newsletter) กิจกรรม รวมถึงข้อความทางการตลาดต่างๆของมูเตเวิร์ล ผ่านระบบ E-mail หรือผ่านแพลตฟอร์มต่างๆ ของมูเตเวิร์ล',
      },
    },
    {
      type: 'policyCheckbox',
      name: 'acceptTerms',
      pageIndex: 1,
      cardIndex: 3,
      properties: {
        policyModalData: {
          title: 'ข้อตกลงและเงื่อนไข',
          content: `
          <h2><strong>Term Of Service</strong><br /><strong>ข้อตกลงและเงื่อนไขการใช้บริการ</strong><br /><strong>"มูเตเวิร์ล Mootae World"</strong></h2>
<p><em>ครอบคลุมถึง ช่องทางการสื่อสาร เว็บไซต์ และแพลตฟอร์มอื่นๆ ของมูเตเวิร์ล ที่มีอยู่และจะเกิดขึ้นในอนาคต</em></p>
<p><br />เพื่อปกป้องสิทธิของทุกฝ่ายที่เกี่ยวข้อง ข้อตกลงและเงื่อนไขการใช้บริการนี้จะกำกับดูแลการใช้บริการกับมูเตเวิร์ล ทั้งบนเว็บไซต์ (Website) และแอพพลิเคชั่น (Application) ทั้งบนระบบปฏิบัติการไอโอเอส ("iOS") และบนระบบปฏิบัติการแอนดรอยด์ ("Android") ตลอดจนช่องทางการติดต่อสื่อสารต่าง ๆ บนแพลตฟอร์ม Social Network ต่างๆ อาทิ Facebook Page, Instagram และ Line เป็นต้น ทั้งนี้ จะประกอบด้วยข้อตกลงและเงื่อนไขด้านล่าง พร้อมกับเงื่อนไขที่กำหนดไว้ในนโยบายความเป็นส่วนตัว <br />ภายใต้ข้อตกลงและเงื่อนไขการใช้บริการต่อไปนี้ ขอให้ท่านอ่านข้อตกลงและเงื่อนไขการใช้บริการที่กำหนดไว้อย่างละเอียด การที่ท่านได้ใช้บริการกับมูเตเวิร์ลนี้ ถือว่าท่านตกลงและยอมรับข้อผูกพันทางกฎหมายที่ระบุไว้ในข้อตกลงและเงื่อนไขการใช้บริการ รวมถึงนโยบายความเป็นส่วนตัวที่บริษัทได้กำหนดไว้ด้วย ดังต่อไปนี้</p>
<p>&nbsp;</p>
<p><strong>ข้อ 1 บทนิยาม</strong><br />ข้อกำหนดการใช้บริการ หมายถึง ข้อกำหนดและเงื่อนไขการใช้บริการและใช้สินค้าต่างๆ ของ มูเตเวิร์ล<br />มูเตเวิร์ล หรือ Mootae World หมายถึง บุคคล หรือ กลุ่มบุคคล หรือทีมงานที่เกี่ยวข้องทั้งหมด ซึ่งเป็นทั้งผู้ให้บริการ, ผลิต, จัดทำ, บริหาร และพัฒนาเว็บไซต์ (Website), แอพพลิเคชั่น (Application) บนระบบปฏิบัติการไอโอเอส ("iOS") และบนระบบปฏิบัติการแอนดรอยด์ ("Android"), รวมถึงการช่องทางการติดต่อสื่อสารต่าง ๆ บนแพลตฟอร์ม Social Network ต่างๆ อาทิ Facebook Page, Instagram และ Line ยังรวมถึงธุรกิจที่เกี่ยวข้องทั้งหมดภายในมูเตเวิร์ลเอง<br />เว็บไซต์ หมายถึง เว็บไซต์ (Website) ของ มูเตเวิร์ล<br />แอพพลิเคชั่น หมายถึง แอพพลิเคชั่น (Application) ที่พัฒนาโดย แ ทั้งบนระบบปฏิบัติการไอโอเอส ("iOS") และบนระบบปฏิบัติการแอนดรอยด์ ("Android")<br />ช่องทางการสื่อสาร หมายถึง แพลตฟอร์มต่าง ๆ หรือ Social Network (Facebook Page, Instagram และ Line) ที่รองรับการติดต่อสื่อสารระหว่างผู้ใช้บริการกับผู้ให้บริการ <br />การให้บริการ หมายถึง การให้บริการ ตลอดการจัดจำน่ายสินค้าในรูปแบบต่าง ๆ ที่จัดขึ้นโดย มูเตเวิร์ล ทั้งที่มีอยู่ และเกิดขึ้นในอนาคต<br />ผู้ให้บริการ หมายถึง มูเตเวิร์ล ตลอดจนทีมงานที่เกี่ยวข้องกับมูเตเวิร์ล ในการให้บริการและสินค้าต่าง ๆ ตลอดจนธุรกิจที่เกี่ยวข้อง<br />ผู้ใช้บริการ หมายถึง ลูกค้าซึ่งลงทะเบียนซื้อสินค้าและบริการ รวมถึงการสมัครสมาชิกกับมูเตเวิร์ลผ่านระบบเว็บไซต์ หรือแอพพลิเคชั่น หรือช่องทางการติดต่อสื่อสารต่างๆ และประสงค์จะรับบริการต่างๆ กับมูเตเวิร์ล ทั้งนี้รวมถึงบุคคลที่เข้ามาสู่เว็บไซต์/แอพพลิเคชั่น หรือช่องทางการติดต่อสื่อสารต่างๆ เพื่อที่จะใช้บริการอีกด้วย <br />รายได้ หมายถึง จำนวนเงินที่ผู้ให้บริการหรือมูเตเวิร์ลได้รับหลังจากให้บริการต่าง ๆ แก่ผู้ใช้บริการจนเสร็จสมบูรณ์</p>
<p>&nbsp;</p>
<p><strong>ข้อ 2 ขอบเขตของข้อตกลงและเงื่อนไขการใช้บริการ</strong><br />ข้อตกลงการใช้บริการนี้ จัดทำขึ้นเพื่อเป็นข้อตกลงระหว่างท่านในฐานะผู้ใช้บริการกับมูเตเวิร์ล โดยข้อตกลงการใช้บริการนี้จะเป็นการตกลงในการใช้งานของผู้ใช้บริการบนเว็บไซต์, แอปพลิเคชั่น, หรือช่องทางการติดต่อสื่อสารบนแพลตฟอร์ม Social Network ต่างๆ (Facebook Page, Instagram และ Line) ซึ่งรวมถึงเนื้อหา การใช้เงิน และการให้บริการทั้งหมดของมูเตเวิร์ลที่ผู้ใช้บริการต้องปฏิบัติตาม<br />ทั้งนี้ เว็บไซต์ แอพพลิเคชั่น และช่องทางการติดต่อสื่อสารบนแพลตฟอร์ม Social Network ต่างๆ ของมูเตเวิร์ล เปิดให้บริการสำหรับผู้ใช้บริการที่มีอายุเกินกว่า 18 ปีบริบูรณ์แล้วเท่านั้น ผู้ใช้บริการจะไม่สามารถใช้บริการผ่านเว็บไซต์ แอพพลิเคชั่น และช่องทางการติดต่อสื่อสารบนแพลตฟอร์ม Social Network ต่างๆ ของมูเตเวิร์ลได้ หากผู้ใช้บริการมีอายุต่ำกว่า 18 ปี เว้นแต่มีผู้ปกครอง (ผู้แทนโดยชอบธรรม หรือผู้ปกครอง) ของผู้ใช้บริการ ในการดูแล ยินยอม หรือให้คำแนะนำ เพื่อทำความเข้าใจในข้อตกลงและเงื่อนไขการให้บริการ ทั้งนี้เพื่อความสะดวกในการใช้บริการให้ถือว่า วันที่ผู้ใช้บริการได้ทำการยอมรับข้อตกลงและเงื่อนไขการให้บริการของมูเตเวิร์ลแล้วนั้น ให้ถือเป็นการยอมรับและอนุญาตในข้อตกลงเงื่อนไขการให้บริการของผู้ปกครองแล้วโดยปริยาย<br />การใช้บริการผ่านเว็บไซต์ แอพพลิเคชั่น ช่องทางการติดต่อสื่อสารบนแพลตฟอร์ม Social Network ต่างๆ ของมูเตเวิร์ล เป็นการแสดงถึงว่าผู้ใช้บริการได้ยืนยันว่ามีอายุผ่านเกณฑ์และมีคุณสมบัติครบที่จะทำการตกลงยอมรับและสัญญาระหว่างผู้ใช้บริการกับมูเตเวิร์ล โดยมูเตเวิร์ลมีสิทธิจะระงับการใช้งานบัญชีหรือรายการการใช้งานของผู้ใช้บริการ หากผู้ใช้บริการมีคุณสมบัติดังกล่าวไม่ครบถ้วนตามที่บริษัทกำหนด ผู้ใช้บริการสามารถติดต่อมูเตเวิร์ลผ่าน Customer Support ได้ ซึ่งระบุไว้บนเว็บไซต์ แอพพลิเคชั่น ช่องทางการติดต่อสื่อสารบนแพลตฟอร์ม Social Network ต่างๆ หากผู้ใช้บริการมีคำถามเกี่ยวกับข้อกำหนดการใช้บริการนี้</p>
<p><br /><br /><strong>ข้อ 3 การยอมรับข้อตกลงและเงื่อนไขการใช้บริการ</strong><br />ผู้ใช้บริการตกลงและปฏิบัติตามเงื่อนไข ซึ่งปรากฏอยู่บนข้อตกลงและเงื่อนไขการใช้บริการฉบับนี้ หรือในฉบับแก้ไขเพิ่มเติมอันอาจจะมีขึ้นในภายหน้า ทั้งนี้ การที่ท่านได้ตกลงในการใช้บริการของ ถือว่าท่านได้ยินยอมและเห็นด้วยกับข้อตกลงและเงื่อนไขการให้บริการฉบับนี้แล้ว <br />&bull; มูเตเวิร์ลสามารถเปลี่ยนแปลงเงื่อนไขการให้บริการได้ตามความเหมาะสม และเงื่อนไขการให้บริการที่มีการเปลี่ยนแปลงจะถูกประกาศให้ทราบบนเว็บไซต์ หรือ แอพพลิเคชั่น หรือ ช่องทางการติดต่อสื่อสารบนแพลตฟอร์ม Social Network ต่างๆ ของมูเตเวิร์ล<br />&bull; ผู้ใช้บริการมีหน้าที่ต้องเข้าไปเยี่ยมชม และตรวจสอบเนื้อหาข้อตกลงที่มีการเปลี่ยนแปลง และได้ประกาศไว้แล้ว หากผู้ใช้บริการได้มีการเข้าใช้บริการหลังจากมีการประกาศเปลี่ยนแปลงไปแล้ว ถือว่าท่านได้ยอมรับและเห็นด้วยในการเปลี่ยนแปลงในเนื้อหาดังกล่าวนั้น และทางมูเตเวิร์ล จะไม่รับผิดชอบต่อความเสียหายใดๆ ของผู้ใช้บริการ อันเกิดจากการไม่ทราบเนื้อหาประกาศของข้อตกลงนั้นๆ<br />&bull; ผู้ใช้บริการ จะต้องลงทะเบียนเป็นผู้ใช้บริการ ผ่านเว็บไซต์ หรือ แอพพลิเคชั่น หรือ ช่องทางการติดต่อสื่อสารบนแพลตฟอร์ม Social Network ต่างๆ ของมูเตเวิร์ล โดยกรอกข้อมูลชื่อ-นามสกุล และข้อมูลส่วนตัวตามความเป็นจริง ของผู้ใช้บริการ และดำเนินตามขั้นตอนการเป็นผู้ใช้บริการด้วยข้อมูลที่เป็นความจริง</p>
<p>&nbsp;</p>
<p><strong>ข้อ 4 รายละเอียดสินค้าและการบริการ</strong><br />การบริการและสินค้าของผู้ให้บริการ (มูเตเวิร์ล) ให้หมายความรวมถึงการให้บริการดังต่อไปนี้ด้วย<br />4.1 บริการรับมูออนไลน์ เป็นบริการโดยทำหน้าที่เป็นตัวแทนผู้ใช้บริการไปไหว้เทพต่าง ๆ เช่น พระพิฆเนศ พระแม่ลักษมี ฯลฯ เป็นต้น ทั้งนี้ในระหว่างทำพิธีไหว้ จะมีการถ่ายคลิป หรือ รูปถ่าย ส่งให้ผู้ใช้บริการดู รวมถึงการบริการเปิดไพ่เพื่อซักถามข้อสงสัยจากองค์เทพแทนผู้ใช้บริการ และบริการอื่น ๆ นอกจากนี้ที่คล้ายคลึงและเกี่ยวข้องกัน<br />4.2 บริการจัดทำวอลเปเปอร์เสริมดวง เป็นบริการจัดทำวอลเปเปอร์ที่ทำขึ้นเฉพาะดวงของผู้ใช้บริการแต่ละท่านเอง โดยวอลเปเปอร์ดังกล่าวนั้นเป็นลิขสิทธิ์ของผู้ให้บริการเอง<br />4.3 จำหน่ายลิขสิทธิ์ลายไพ่ทาโร่ เป็นการจำหน่ายลิขสิทธิ์ลายไพ่ทาโร่ซึ่งจัดทำขึ้นเองโดยผู้ให้บริการเอง สำหรับผู้ใช้บริการที่สนใจนำไปใช้ประกอบการทำนายดวงของตน<br />4.4 จำหน่ายแพ็กเกจ หรือบริการอื่น ๆ ที่เกี่ยวข้อง โดยทางผู้ให้บริการผลิตเอง หรือ ได้รับลิขสิทธิ์ในการให้บริการ ซึ่งผู้ใช้บริการสามารถใช้ช่องทางการชำระเงินโดยการหักเงินจากบัญชีธนาคาร บัตรอิเล็กทรอนิกส์ หรือเติมเงินจากผู้ให้บริการ หรือช่องทางอื่นๆ ที่ผู้ให้บริการได้อนุญาตไว้<br />4.5 บริการข่าวสารต่างๆ ที่เกี่ยวข้องกับดวงชะตา และประเด็นอื่นๆ ที่เกี่ยวข้อง ทั้งของมูเตเวิร์ลดำเนินการเอง หรือผู้ค้าทางธุรกิจผลิตขึ้น โดยเป็นเนื้อหาเกี่ยวข้องกับการทำนายในทุกแขนงสาขาวิชาต่าง ๆ ผ่านระบบ E-mail หรือ ช่องทางการสื่อสาร หรือ เว็บไซด์ และ แพลตฟอร์มต่างๆ ของมูเตเวิร์ล</p>
<p><br /><br /><strong>ข้อ 5 เนื้อหาของการใช้บริการ</strong><br />มูเตเวิร์ล จะไม่รับผิดชอบการเก็บรักษาข้อมูลใดๆ หรือข้อมูลการใช้งานของผู้ใช้บริการที่ใช้บริการอย่างผิดวัตถุประสงค์ หรือผิดเงื่อนไขการให้บริการหรือผิดกฎหมายไทย หรือกฎหมายระหว่างประเทศที่ใช้บังคับ<br />5.1 มูเตเวิร์ล จะให้บริการตามเงื่อนไขการให้บริการ หรือตามกฎหมายไทย หรือกฎหมายระหว่างประเทศที่ใช้ เพื่อให้บริการของ มูเตเวิร์ล ได้ผลิต หรือได้รับสิทธิให้แก่ผู้ใช้บริการ<br />5.2 ในกรณีที่ มูเตเวิร์ล มีความจำเป็นต้องเพิ่มเนื้อหาหรือเงื่อนไขการให้บริการต่าง ๆ หรือ เพื่อความจำเป็นในการบริหารช่องทางการติดต่อสื่อสารต่าง ๆ เช่น Facebook Page, Instagram และ Line ผู้ใช้บริการตกลงยินยอมให้ มูเตเวิร์ล มีสิทธิเปลี่ยนแปลงได้เป็นครั้ง ๆ ไป ทั้งในรูปแบบการอัพเดทข้อมูลทางออนไลน์และออฟไลน์<br />5.3 มูเตเวิร์ล จะประกาศเงื่อนไขการให้บริการ และข้อกำหนดหรือ ข้อบังคับใดๆ ที่เกี่ยวข้องกับกฎหมายไทยหรือกฎหมายระหว่างประเทศที่ใช้บังคับ รวมถึงเกี่ยวกับเงื่อนไขการให้บริการของมูเตเวิร์ลอย่างสม่ำเสมอ ผู้ใช้บริการตกลงและให้ความยินยอมกับเงื่อนไขการให้บริการมูเตเวิร์ลทุกประการ ทั้งนี้ ผู้ใช้บริการจะต้องตรวจสอบประกาศเงื่อนไขการให้บริการและข้อกำหนดหรือข้อบังคับใดๆ ที่เกี่ยวข้องกับกฎหมายไทยหรือกฎหมายระหว่างประเทศที่ใช้บังคับ รวมถึงเงื่อนไขการให้บริการต่าง ๆ ด้วยตนเองอย่างสม่ำเสมอ มูเตเวิร์ล จะไม่รับผิดชอบความเสียหายใดๆ ของผู้ใช้บริการ เนื่องจากไม่ได้เข้ามาตรวจสอบประกาศเงื่อนไขการให้บริการและข้อกำหนดหรือข้อบังคับใดๆ ที่เกี่ยวข้องกับกฎหมายไทยหรือกฎหมายระหว่างประเทศที่ใช้บังคับ เกี่ยวกับเงื่อนไขการให้บริการบนช่องทางต่าง ๆ ที่มูเตเวิร์ลจัดไว้ให้</p>
<p>&nbsp;</p>
<p><strong>ข้อ 6 การสร้างบัญชีหรือการลงทะเบียนในการใช้บริการ</strong><br />เมื่อผู้ใช้บริการให้ข้อมูลของตนโดยการลงทะเบียนแก่มูเตเวิร์ลในการขอใช้บริการต่างๆ แล้ว มูเตเวิร์ลจะให้บัญชี (Account) หรือ Code และรหัสผ่านแก่ผู้ใช้บริการตามที่ผู้ใช้บริการลงทะเบียน ทางมูเตเวิร์ลจะทำการเก็บข้อมูล Device ID,เบอร์โทรศัพท์, อีเมล์, เพศ, วันเดือนปีเกิด และรหัสผ่านการเข้าใช้บริการของผู้ใช้บริการไว้ในระบบที่ถูกต้อง สมบูรณ์ เพื่อดำเนินการใช้บริการบัญชีที่ถูกต้องตรงตามความเป็นจริงอยู่เสมอ<br />ทั้งนี้ มูเตเวิร์ลจะดูแลจัดการข้อมูลบัญชี รหัสผ่าน และข้อมูลของผู้ใช้บริการต่างๆ เพื่อปกป้องข้อมูลส่วนบุคคล ซึ่งมูเตเวิร์ลขอรับรองว่าจะเก็บข้อมูลของสมาชิกไว้เป็นความลับอย่างดีที่สุด ไม่ดำเนินการใดๆ ที่เป็นการละเมิดสิทธิ์ของผู้อื่นทางกฎหมาย หรือหน้าที่ตามกฎหมายที่มีต่อบุคคลใด ๆ มินำไปเปิดเผยที่อื่นใด โดยไม่ได้รับอนุญาต เว้นเสียแต่มีเอกสารทางกฎหมาย เพื่อตรวจสอบข้อมูลของผู้กระทำผิด<br />นอกจากนี้ ผู้ใช้บริการตกลงรับผิดชอบในการดูแลบัญชีและรหัสผ่านของตัวเอง และรับผิดชอบต่อความเสียหายในการใช้บริการ ทั้งนี้ ในกรณีที่ข้อมูลส่วนบุคคลดังกล่าว ถูกจารกรรมโดยวิธีการทางอิเล็กทรอนิกส์ หรือสูญหาย เสียหายอันเนื่องจากเหตุสุดวิสัยหรือไม่ว่ากรณีใดๆ ทั้งสิ้น ผู้ใช้บริการซึ่งเป็นผู้รับผิดชอบดูแลบัญชีจะเป็นคนรับผิดชอบทั้งหมด โดยมูเตเวิร์ลจะไม่รับผิดชอบใดๆ ทั้งสิ้น และจะไม่มีส่วนเกี่ยวข้องหรือรับผิดชอบใดๆ กับการใช้งาน มอบ ซื้อขาย เช่า ยืม โอน อนุญาต หรือใช้เป็นหลักประกัน ร่วมกันใช้ หรือ การถ่ายโอนสิทธิการใช้งานบัญชีและรหัสผ่านไม่ว่ารูปแบบใดๆ ทั้งสิ้น</p>
<p><br /><br /><strong>ข้อ 7 การใช้และการป้องกันข้อมูลส่วนบุคคล</strong><br />ภายใต้บทบัญญัติตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 ข้อมูลทั้งหมดที่ให้ไว้ หรือข้อมูลอันเกิดจากการเก็บรวบรวมในการเชื่อมต่อกับบริการของมูเตเวิร์ลจะเป็นไปตามนโยบายความเป็นส่วนตัวของมูเตเวิร์ล ทั้งนี้ มูเตเวิร์ลอาจใช้ข้อมูลที่ได้รับเกี่ยวกับการใช้งาน หรือการบริการภายใต้เงื่อนไขนโยบายความเป็นส่วนตัว โดยมูเตเวิร์ล ใช้ข้อมูลดังกล่าวเพื่อวัตถุประสงค์ทางการตลาด โฆษณา ประชาสัมพันธ์ของมูเตเวิร์ล นอกจากนี้ข้อมูลที่ท่านให้แก่มูเตเวิร์ล ที่ประชาชนทั่วไปอาจสามารถเข้าถึงข้อมูลนั้นได้ ท่านควรรักษาข้อมูลเป็นอย่างดีเพื่อรักษาข้อมูลส่วนตัวหรือข้อมูลที่มีความสำคัญกับท่าน มูเตเวิร์ลจะไม่รับผิดชอบรักษาข้อมูลใด ๆ ดังกล่าว และจะไม่รับผิดชอบในการรักษาข้อมูลความเป็นส่วนตัวของจดหมายอิเล็กทรอนิกส์ หรือข้อมูลอื่น ๆ ที่ผ่านทางอินเทอร์เน็ตหรือเครือข่ายอื่น ๆ ที่ท่านอาจจะใช้ มูเตเวิร์ลขอสงวนสิทธิ์ในการควบคุมและรับผิดชอบต่อการกระทำของท่าน เพื่อประโยชน์สาธารณะตามกฎหมายไทยและกฎหมายนานาประเทศที่ใช้บังคับ<br />นอกจากนี้ มูเตเวิร์ลสงวนสิทธิ์ในการบันทึกเนื้อหาภาพ และเสียงสนทนาที่เกิดขึ้น ระหว่างผู้ใช้บริการภายในเว็บไซต์, แอปพลิเคชั่น, หรือช่องทางการติดต่อสื่อสารบนแพลตฟอร์ม Social Network ต่างๆ และสามารถเรียกดูได้ในกรณีที่พิจารณาเห็นว่ามีความจำเป็นในกรณีเกิดข้อพิพาทต่างๆ และเพื่อรักษาระเบียบและเงื่อนไขในการใช้บริการภายในมูเตเวิร์ลเอง ทั้งนี้ ข้อมูลดังกล่าว มูเตเวิร์ลจะเป็นผู้จัดเก็บแต่เพียงผู้เดียว โดยจะควบคุมและป้องกันด้วยระบบการจัดการข้อมูลตามแนวทางของมูเตเวิร์ลเอง ยกเว้นกรณี ระบบการพิมพ์สนทนาของบุคคลที่สามซึ่งการให้บริการแก่บุคคลที่ 3 นั้น จะสามารถเก็บและรักษาได้ตามข้อตกลงการใช้บริการของบุคคลที่สาม หรือบุคคลที่สามให้ความยินยอม<br />อีกทั้ง มูเตเวิร์ลจะบันทึกและเก็บรักษาเนื้อหาการสนทนาทุกอย่างที่เกิดขึ้นระหว่างผู้ใช้บริการภายในเว็บไซต์, แอปพลิเคชั่น, หรือช่องทางการติดต่อสื่อสารบนแพลตฟอร์ม Social Network ต่างๆ ของมูเตเวิร์ล เช่น การพิมพ์ข้อความสนทนากับทีมงานผู้ให้บริการ การสนทนากับทีมงานของผู้ให้บริการ ซึ่งรวมถึงภาพและเสียงในการสนทนา เป็นต้น</p>
<p>&nbsp;</p>
<p><br /><strong>ข้อ 8 ความรับผิดชอบและหน้าที่ของผู้ใช้บริการ</strong><br />8.1 ไม่สร้างความเดือดร้อนให้ทีมงานมูเตเวิร์ล ไม่ว่าจะในรูปแบบใดก็ตาม<br />8.2 ไม่ประพฤติตนซึ่งเป็นอุปสรรคต่อการทำงาน และการให้บริการของ มูเตเวิร์ล<br />8.3 ยังคงมีหน้าที่ และความรับผิดอื่นๆ ตามกฎหมายที่ใช้บังคับ ทั้งในประเทศและต่างประเทศ<br />8.4 ห้ามเปิดเผยข้อมูลของทีมงานมูเตเวิร์ล โดยไม่ได้รับความยินยอมดังกล่าวนั้น<br />8.5 ห้ามผู้ใช้บริการเผยแพร่ หรือคอมเม้นต์ ไม่ว่าจะเป็น บทความ ถ้อยคำ รูปภาพ หรือ ลักษณะใดๆ อันเป็นการหมิ่นประมาท ไม่เหมาะสม ลามก อนาจาร หยาบคาย หรือน่ารังเกียจ รวมถึงการกระทำหรือ การกล่าวอ้างอื่นๆ ในทำนองที่สร้างความเสียหายให้กับ มูเตเวิร์ล หรือ ทีมงานที่เกี่ยวข้อง โดยมิได้มีเหตุอันควร มิฉะนั้น มูเตเวิร์ล มีความจำเป็นจะต้องดำเนินคดีตามกฎหมายต่อไป<br />8.6 ไม่มีพฤติกรรมฉ้อโกงหรือหาประโยชน์อื่นใดโดยมิชอบต่อ มูเตเวิร์ล<br />8.7 ไม่กระทำผิดตามข้อกฎหมายใดๆ รวมถึงไม่ละเมิดในทรัพย์สินทางปัญญาหรือสิทธิอื่นๆ ในรูปแบบใดๆ ทั้งสิ้น<br />8.8 ไม่นำเข้าหรือส่งออกหรือเผยแพร่ Virus หรือทำการ Hack ใดๆ กับระบบการให้บริการของ มูเตเวิร์ล<br />8.9 ปฏิบัติตามข้อตกลงและเงื่อนไขการใช้บริการนี้ หรือกฎหมายอื่นๆ ที่เกี่ยวข้อง<br />8.10 หากผู้ใช้บริการพบว่ามีการใช้บริการที่ผิดข้อตกลง และเงื่อนไขการให้บริการนี้หรือผิดกฎหมายใดๆ โดยบัญชีหรือรหัสผ่านซึ่งเป็นของผู้ใช้บริการ ให้ผู้ใช้บริการแจ้ง มูเตเวิร์ล ทราบทันที หากพบว่าการใช้บริการนั้นเกิดจากความประมาทเลินเล่อของผู้ใช้บริการเอง มูเตเวิร์ลจะไม่รับผิดชอบใดๆทั้งสิ้น</p>
<p><br /><br /><strong>ข้อ 9. การแจ้งการละเมิดการใช้บริการ</strong><br />9.1. หาก มูเตเวิร์ล พบเห็นว่า มีการกระทำที่ไม่เหมาะสม หรือ ไม่เป็นไปตามเงื่อนไขข้อตกลง หรือ ได้รับการแจ้งเตือนมาจากผู้ใช้บริการอื่นๆ มูเตเวิร์ล จะทำการเตือนผู้ใช้บริการนั้น โดยจะเป็นการเตือนผ่านจดหมายอิเล็กทรอนิกส์ (Email) หรือการแสดงบนหน้าเว็บไซด์ หรือช่องการสื่อสารอื่นๆ (Facebook Page, Instagram, Line) ที่มูเตเวิร์ได้ใช้ในการติดต่อสื่อสาร โดยผู้ใช้บริการดังกล่าวได้ทำการลงชื่อเข้าใช้งาน<br />9.2. การเตือนดังกล่าวจะไม่ส่งผลต่อการใช้บริการต่างๆ ของมูเตเวิร์ล แต่อาจะส่งผลต่อการระงับบัญชี (Account) การใช้งานในภายหลัง หากปรากฏว่าผู้ใช้บริการยังคงกระทำการไม่เหมาะสมกับมูเตเวิร์ล ในช่องทางต่าง ๆ นั้น</p>
<p>&nbsp;</p>
<p><strong>ข้อ 10.เงื่อนไขการชำระค่าบริการ</strong> <br />10.1 มูเตเวิร์ล สนับสนุนวิธีการชำระเงินสำหรับการใช้บริการต่างๆ ดังต่อไปนี้<br />(1) บัตรเครดิต<br />การชำระผ่านบัตรเครดิตจะดำเนินการผ่านช่องทางการชำระเงินของบุคคลภายนอก และชนิดของบัตรเครดิตที่ช่องทางการชำระเงินเหล่านี้ยอมรับอาจแตกต่างกันไปตามเขตอำนาจตามกฎหมายของแต่ละประเทศ <br />(2) การโอนเงินผ่านธนาคาร<br />ผู้ใช้บริการสามารถชำระเงินผ่านเครื่องเอทีเอ็มหรือโอนเงินผ่านธนาคารทางอินเทอร์เน็ต ("การโอนเงินผ่านธนาคาร") ไปยังบัญชีมูเตเวิร์ลที่กำหนดไว้ ทั้งนี้ผู้ใช้บริการจะต้องส่งใบเสร็จการรับโอนเงินหรือหมายเลขอ้างอิงการทำรายการชำระเงินให้แก่ มูเตเวิร์ล เพื่อทำการตรวจสอบและเป็นการยืนยันการชำระเงิน หาก มูเตเวิร์ล ไม่ได้รับการยืนยันการชำระเงินภายในสาม (3) วัน คำสั่งซื้อบริการของผู้ใช้บริการจะถูกยกเลิก<br />10.2 ผู้ใช้บริการสามารถเปลี่ยนวิธีการชำระเงินที่ต้องการได้ โดยจะต้องเปลี่ยนก่อนทำการชำระเงินเท่านั้น<br />10.3 มูเตเวิร์ล ไม่รับผิดชอบ และจะไม่ยอมรับผิดใดๆ ต่อความสูญเสียหรือความเสียหายแก่ผู้ใช้บริการอันเกิดจากข้อมูลการจัดส่ง และ/หรือ ข้อมูลการชำระเงินที่ผู้ใช้บริการป้อนไว้ หรือการที่ผู้ใช้บริการโอนเงินค่าบริการหรือชำระสินค้าที่ซื้อไม่ถูกต้อง มูเตเวิร์ลขอสงวนสิทธิ์ในการตรวจสอบว่าผู้ใช้บริการได้รับอนุญาตอย่างเหมาะสมให้ใช้วิธีการชำระเงินบางอย่าง และอาจระงับธุรกรรมไว้จนกว่าจะได้ยืนยันการอนุญาตนั้นแล้ว หรือยกเลิกธุรกรรมที่เกี่ยวข้องกรณีไม่มีการยืนยันดังกล่าว<br />10.3 การคืนเงิน ในกรณีที่ผู้ใช้บริการเกิดปัญหาในการรับบริการต่าง ๆ จึงต้องการจะยกเลิกการรับบริการนั้น และขอรับเงินคืน จำนวนเงินที่เกี่ยวข้องกับการบริการที่ถูกยกเลิกจะถูกคืนให้กับผู้ใช้บริการเป็นเครดิตบนบัญชีระบบของ มูเตเวิร์ล เท่านั้น การคืนเงินเป็นไปตามเงื่อนไขของการขอยกเลิกบริการตามที่ มูเตเวิร์ล กำหนด</p>
<p>&nbsp;</p>
<p><strong>ข้อ 11. ข้อตกลงและการยกเลิกการให้บริการ</strong><br />ในกรณีที่เกิดปัญหาในการบริการหรือการใช้สินค้า หรือเกิดข้อพิพาทขึ้น ผู้ใช้บริการสามารถติดต่อให้มูเตเวิร์ลช่วยแก้ไขปัญหาดังกล่าวได้ โดยมูเตเวิร์ลขอสงวนสิทธิ์ในการไม่รับผิดชอบต่อปัญหาใดๆ ที่เกิดขึ้นด้วยความประมาทของผู้ใช้บริการเอง ทั้งนี้<br />11.1 บริการไม่สามารถถูกยกเลิกได้หาก มูเตเวิร์ลได้ให้บริการตามที่ได้บรรยายไว้ในรายละเอียดของบริการ ทั้งนี้ หากผู้ใช้บริการไม่พึงพอใจต่อการให้บริการ ผู้ใช้บริการสามารถแจ้งต่อ มูเตเวิร์ล โดยตรงผ่านช่องทางการติดต่อสื่อสารต่าง ๆ<br />11.3 มูเตเวิร์ล ขอสงวนสิทธิ์ในการยกเลิกบริการ และ/หรือ คืนเงินที่เกี่ยวข้องกับการให้บริการโดยไม่ต้องแจ้งให้ทราบล่วงหน้า หาก มูเตเวิร์ล สังเกตเห็นการฉ้อโกงในการใช้บริการดังกล่าว หรือ การกระทำการละเมิดข้อกำหนดการใช้บริการ หรือ การกระทำที่ไม่เหมาะสมบนช่องทางสื่อสารต่าง ๆ หรือ แพลตฟอร์ม ของมูเตเวิร์ล รวมถึงการกระทำดังกล่าวดังต่อไปนี้<br />&bull; ข้อความที่ทำให้บุคคลอื่นเสียหาย เสื่อมเสียชื่อเสียงหรือเสียเกียรติยศ ซึ่งรวมถึงทีมงานของมูเตเวิร์ลเองด้วย<br />&bull; ใช้คำหยาบคาย หรือด่าทอกัน หรือมีการพาดพิงถึงบุพพการี<br />&bull; ก่อกวน และก่อให้เกิดความเสียหายต่อการให้บริการของมูเตเวิร์ล<br />&bull; ข้อความสนับสนุนการกระทำที่ทุจริตต่อมูเตเวิร์ล<br />&bull; ละเมิดสิทธิบุคคลอื่น หรือละเมิดสิทธิของมูเตเวิร์ลเองด้วย<br />&bull; ละเมิดข้อตกลงและเงื่อนไขการใช้บริการนี้ ตลอดจนกฎหมายที่เกี่ยวข้อง หรือจารีตประเพณี หรือศีลธรรมอันดีของประชาชน<br />&bull; นำภาพ เนื้อหา หรือทรัพย์สินทางปัญญาที่ผลิตโดยมูเตเวิร์ลไปใช้โดยมิได้รับอนุญาต<br />&bull; ข้อความที่มีจุดมุ่งหมายเพื่อหวังผลประโยชน์ใดๆ โดยที่ไม่ได้รับอนุญาตจากมูเตเวิร์ล <br />&bull; ข้อความที่มีเนื้อหาสื่อไปในทางที่ไม่สุภาพ หรือคำหยาบคาย<br />&bull; ข้อความหรือรูปภาพลามก อนาจาร<br />&bull; โฆษณาโดยไม่เกี่ยวกับมูเตเวิร์ล โดยการนำไปสู่เว็บไซต์อื่น<br />&bull; โฆษณาผู้ค้ารายอื่น และรวมถึงการกระทำต่างๆ ที่พยายามชักจูงไปใช้บริการของผู้ค้ารายอื่น<br />&bull; โฆษณาถึงเว็บไซต์ผิดกฎหมาย หรือเว็บไซต์ขยะต่างๆ<br />&bull; ให้ข้อมูลที่เป็นเท็จ หรือบิดเบือน เกี่ยวกับ มูเตเวิร์ล<br />&bull; แอบอ้างว่าเป็นผู้บริหารหรือเจ้าหน้าที่ของ มูเตเวิร์ล<br />&bull; ใช้วิธีโอนเงินในลักษณะทุจริตหรือหลอกลวง<br />&bull; ไม่ชำระค่าบริการภายในเวลาที่กำหนด หรือ มูเตเวิร์ลไม่สามารถตรวจสอบการชำระเงินได้ เนื่องจากการชำระผิดของผู้ใช้บริการเอง การเติมเงินหรือชำระค่าบริการไม่สามารถขอคืนได้ทุกกรณี ไม่ว่าทั้งหมดหรือบางส่วน<br />&bull; ผู้ใช้บริการลงทะเบียนด้วยการกรอกข้อมูลอันเป็นเท็จ หรือใช้ข้อมูลของบุคคลอื่นในการสมัครใช้บริการ</p>
<p>&nbsp;</p>
<p><strong>ข้อ 12 ระยะเวลาและการเปลี่ยนแปลงสิทธิการให้บริการ</strong> <br />ระยะเวลาในการให้บริการของมูเตเวิร์ล ผู้ใช้บริการสามารถใช้บริการได้ทุกวัน โดยที่มูเตเวิร์ลจะไม่คิดค่าบริการในการเข้าใช้บริการในทุกแพลตฟอร์มของมูเตเวิร์ล เว้นแต่มูเตเวิร์ลมีสิทธิ์หยุดให้บริการชั่วคราวเนื่องจากเหตุจำเป็น หรือเหตุอื่นที่หลีกเลี่ยงไม่ได้เกิดขึ้นในระหว่างหรือขณะให้บริการ หรือเหตุฉุกเฉินอื่นๆ ซึ่งมูเตเวิร์ลจะมีการประกาศให้ทราบล่วงหน้าถ้าเหตุจำเป็น เหตุอื่น หรือเหตุฉุกเฉินอื่น ดังกล่าวสามารถคาดหมายได้ ทั้งนี้ให้หมายความรวมถึงเหตุสุดวิสัยอื่นใดตามกฎหมายด้วย<br />ทั้งนี้ มูเตเวิร์ลขอสงวนสิทธิ์ในการแก้ไขเปลี่ยนแปลง หรือระงับ ยกเลิก หรือหยุดการให้บริการชั่วคราวหรือถาวร ไม่ว่าทั้งหมดหรือบางส่วนของการให้บริการ โดยไม่ต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า ทั้งนี้มูเตเวิร์ลอาจระงับ เลื่อน การอนุญาต การใช้บริการ หากมีกรณีดังต่อไปนี้<br />&bull; กรณีที่มูเตเวิร์ลไม่สามารถดำเนินการให้บริการได้อย่างเต็มรูปแบบ อันเนื่องจากเหตุการณ์ หรือปัจจัยบางอย่างที่มูเตเวิร์ลไม่สามารถควบคุมได้<br />&bull; กรณีที่มีข้อผิดพลาดเกิดขึ้นกับซอฟท์แวร์และฮาร์ดแวร์ที่รองรับการทำงานของแพลตฟอร์มทั้งหมดของมูเตเวิร์ล ทั้งในฝั่งของมูเตเวิร์ลเอง หรือฝั่งของผู้ให้บริการบุคคลที่สามที่มูเตเวิร์ลใช้บริการด้วย<br />&bull; กรณีที่มีข้อผิดพลาดเกิดขึ้น ในขั้นตอนการชำระและการตรวจสอบค่าบริการต่างๆ ของมูเตเวิร์ล<br />&bull; กรณีที่มีการบำรุงรักษาและปรับปรุงระบบของการให้บริการที่เกี่ยวข้องกับซอฟต์แวร์และฮาร์ดแวร์ และอุปกรณ์สื่อสารอิเล็กทรอนิกส์ ทั้งในฝั่งของมูเตเวิร์ลเอง หรือฝั่งของผู้ให้บริการบุคคลที่สามที่มูเตเวิร์ลใช้บริการด้วย<br />&bull; กรณีที่เกิดเหตุการณ์ หรือสถานการณ์อื่นๆ โดยทางธรรมชาติเอง หรือด้วยฝีมือมนุษย์ก็ตาม เช่น ภัยธรรมชาติต่างๆ หรือการแฮกเพื่อเข้าสู่ระบบของแฮกเกอร์ เป็นต้น รวมถึงปัจจัยหรือเหตุสุดวิสัยอื่นที่มูเตเวิร์ลไม่สามารถควบคุมได้<br />มูเตเวิร์ลไม่รับผิดชอบต่อความเสียหายที่เกิดขึ้นต่อผู้ใช้บริการหรือบุคคลอื่น จากการกระทำการหยุดให้บริการ ระงับ เลื่อน หรือเปลี่ยนแปลงสิทธิใดๆ ตามในข้อ 11 นี้ในกรณีฉุกเฉิน เพื่อป้องกันสมาชิกคนอื่นๆ หรือบุคคลที่สามหรือเพื่อรักษาความปลอดภัยที่สมบูรณ์ของข้อมูล</p>
<p>&nbsp;</p>
<p><strong>ข้อ 13 การยกเว้นความรับผิด (Disclaimer)</strong><br />มูเตเวิร์ล เน้นการให้บริการที่นำเสนอข้อมูลให้ถูกต้องมากที่สุดตามหลักวิชาพยากรณ์ศาสตร์เท่าที่จะทำได้ ซึ่งอาจมีการจัดเรียง วางรูปแบบเนื้อหาต่าง ๆ โดยเลือกใช้หลักการบางส่วนบางตำราตามเหมาะสม หรือตามสมัยนิยม ซึ่งอาจจะไม่ครอบคลุมตำราโหราศาสตร์ที่มีทั้งหมดในปัจจุบัน หรือใช้เฉพาะกลุ่มเฉพาะสำนัก ดังนั้น มูเตเวิร์ลขอสงวนสิทธิ์ไม่รับรองความถูกต้อง ไม่รับประกัน หรือยืนยันความสมบูรณ์ของข้อมูลใด ๆ ภายใต้การใช้บริการในแพลตฟอร์มต่าง ๆ ของมูเตเวิร์ล รวมถึงการบริการอื่นที่มีให้การบริการของมูเตเวิร์ลรวมอยู่ด้วย มูเตเวิร์ลจะไม่รับผิดชอบเกี่ยวกับความเสียหายที่เกิดจากการบริการอื่นนั้นเช่นกัน<br />นอกจากนี้ มูเตเวิร์ลได้รับการยกเว้นความรับผิด ในกรณี่ไม่สามารถให้บริการได้เนื่องจากเหตุสุดวิสัยต่าง ๆ หรือ เหตุการณ์ที่หลีกเลี่ยงไม่ได้ ซึ่งหมายความรวมถึงเหตุขัดข้องทางไฟฟ้า หรือ โทรคมนาคม การตรวจสอบแก้ไขเปลี่ยนแปลงระบบอุปกรณ์ (ซึ่งประกาศไปล่วงหน้าแล้ว) รวมถึงปัจจัยอื่นๆ ที่มูเตเวิร์ลไม่สามารถควบคุมได้ อีกทั้งไม่รับผิดชอบเกี่ยวกับการระงับการให้บริการ หรือข้อบกพร่องในการใช้บริการ เนื่องมาจากผลทางกฎหมายใดหรือการกระทำผิดกฎหมายของผู้ใช้บริการเอง ทั้งโดยตรง โดยอ้อม โดยประมาท และโดยประมาทเลินเล่ออย่างร้ายแรง<br />มูเตเวิร์ลจะไม่รับผิดชอบทางกฎหมาย ในกรณีที่มีความผิดพลาดหรือละเลยในการให้ข้อมูลหรือการใช้ประโยชน์ไม่ได้ของข้อมูลที่เกิดจากการให้บริการต่าง ๆ รวมถึงความสูญเสีย ความเสียหายหรือการถูกทำลายใด ๆ ที่เกิดขึ้นจากการเผยแพร่ หรือการใช้ข้อมูลเหล่านี้ทั้งโดยตรงและโดยอ้อม รวมถึงในกรณีที่ผู้ใช้บริการไม่สามารถทำกำไรหรือได้รับประโยชน์อื่นใดตามที่ผู้ใช้บริการคาดหมายไว้ และความเสียหายจากการเลือกใช้บริการ หรือการใช้บริการของผู้ใช้บริการเอง</p>
<p><br /><br /><strong>ข้อ 14 ขอบเขตและข้อจำกัดในการใช้บริการ</strong><br />14.1 มูเตเวิร์ล เป็นผู้ถือสิทธิและอำนาจทั้งหมดในข้อมูลทุกประการในเว็บไซต์ หรือ แอพพลิเคชั่น ของมูเตเวิร์ล รวมถึงภายในช่องทางการติดต่อสื่อสารบนแพลตฟอร์ม Social Network ต่างๆ เฉพาะส่วนที่มูเตเวิร์ลสามารถเข้าถึงและใช้งานได้ ในกรณีที่มูเตเวิร์ลเล็งเห็นความจำเป็นในการควบคุมหรือปรับปรุงระบบต่างๆ มูเตเวิร์ลสามารถเพิ่มเติม ลบ เปลี่ยนแปลงได้<br />14.2 ข้อมูลบัญชีและรหัสผ่านทั้งหมด รวมไปถึงข้อมูลต่างๆ ที่อยู่ในบัญชี ทั้งในเว็บไซต์ หรือ แอพพลิเคชั่น ของมูเตเวิร์ล รวมถึงภายในช่องทางการติดต่อสื่อสารบนแพลตฟอร์ม Social Network ต่างๆ เฉพาะส่วนที่มูเตเวิร์ลสามารถเข้าถึงและใช้งานได้ เป็นทรัพย์สินของมูเตเวิร์ล ไม่ว่าข้อมูลดังกล่าวจะได้มาด้วยวิธีการใดก็ตาม ทั้งนี้ มูเตเวิร์ลเพียงแต่ให้สิทธิแก่ผู้ใช้ในการใช้บัญชี รหัสผ่าน ภายในระยะเวลาการให้บริการเท่านั้น และมูเตเวิร์ลขอสงวนสิทธิ์ในการเปลี่ยนแปลง เรียกคืน ระงับ หรือยกเลิกบัญชี รหัสผ่าน ได้ทุกเมื่อ หากสัญญาการให้บริการระหว่างมูเตเวิร์ลกับผู้ใช้บริการถูกแก้ไข สิ้นสุดลง หรือถูกยกเลิก รวมไปถึงการดำเนินการเพื่อให้เป็นไปตามข้อตกลงการใช้บริการ โดยไม่ต้องแจ้งให้ทราบล่วงหน้า และมูเตเวิร์ลไม่รับผิดต่อความเสียหายที่เกิดขึ้นต่อผู้ใช้บริการหรือบุคคลอื่นจากการกระทำดังกล่าว<br />14.3 มูเตเวิร์ลสามารถระงับการใช้บัญชีของผู้ใช้บริการได้ ทั้งในระบบเว็บไซต์ หรือ แอพพลิเคชั่น ของมูเตเวิร์ล หากฝ่าฝืนข้อกำหนดหน้าที่ของผู้ใช้บริการอันเนื่องจาการใช้บัญชีในทางมิชอบจากบุคคลที่สาม หรือเกิดความเสียหายในการใช้บริการอันเกิดแก่ ผู้ใช้บริการอันเนื่องมาจากการรั่วไหลของบัญชีหรือรหัสผ่านในการดูแลของผู้ใช้บริการเอง<br />14.4 มูเตเวิร์ลสามารถระงับการใช้งานบัญชี และข้อมูลทุกอย่างของผู้ใช้บริการภายในระบบเว็บไซต์ หรือ แอพพลิเคชั่น ของมูเตเวิร์ล จากการพิจารณาตามความเหมาะสมในการควบคุมหรือหมายกำหนดการต่างๆ ของระบบเว็บไซต์ หรือ แอพพลิเคชั่น นั้น<br />14.5 มูเตเวิร์ลเป็นผู้ถือสิทธิและอำนาจทั้งหมดในข้อมูลทุกประการของผู้ใช้บริการภายในระบบเว็บไซต์ หรือ แอพพลิเคชั่น ของมูเตเวิร์ล ในกรณีที่มูเตเวิร์ลเล็งเห็นความจำเป็นในการควบคุมหรือปรับปรุงระบบเว็บไซต์ หรือ แอพพลิเคชั่น ของมูเตเวิร์ล สามารถเพิ่มเติม ลบ เปลี่ยนแปลงได้</p>
<p>&nbsp;</p>
<p><br /><strong>ข้อ 15 สิทธิในทรัพย์สินทางปัญญา</strong><br />มูเตเวิร์ล มีความเป็นเจ้าของหรือมีกรรมสิทธิ์ในทรัพย์สินทางปัญญาบนเว็บไซด์ และแอปพลิเคชั่น รวมถึงที่ปรากฏบนช่องทางการติดต่อสื่อสารต่าง ๆ แต่เพียงผู้เดียว ผลงานหรือข้อมูลทั้งหมดนี้ ไม่ว่าจะเป็นในรูปแบบลิขสิทธิ์ สิทธิบัตร เครื่องหมายการค้าและสิทธิในทรัพย์สินทางปัญญากรรมสิทธิ์หรือสิทธิอื่นๆ ห้ามมิให้ทำซ้ำ โอน เปลี่ยนแปลง แก้ไข เผยแพร่ หรือในรูปแบบอื่นๆ ไม่ว่าทั้งหมดหรือแต่บางส่วน โดยไม่ได้รับอนุญาตเป็นลายลักษณ์อักษรจาก มูเตเวิร์ล อย่างเด็ดขาด ทั้งนี้ ผู้ละเมิดจะถูกดำเนินคดีตามกฎหมายอย่างสูงสุด</p>
<p>&nbsp;</p>
<p><strong>ข้อ 16 กฎหมายที่ใช้บังคับ</strong><br />การตีความและการประยุกต์ใช้ข้อตกลงและเงื่อนไขการให้บริการนี้ให้เป็นไปตามกฎหมายไทย ที่มีผลใช้บังคับ</p>`,
        },
      },
    },
  ],
  summaryFields: [
    {
      type: 'readonlyInput',
      name: 'collection',
      label: 'คอลเลคชันวอลเปเปอร์ที่คุณลูกค้าสั่งซื้อ',
      labelFontWeight: '700',
      properties: {
        readonlyInputValue: 'เทพเซียน Collection',
      },
      cardIndex: 0,
    },
    {
      name: 'template',
      cardIndex: 1,
    },
    {
      name: 'choice',
      label: 'เรื่องที่ต้องการเสริม',
      cardIndex: 1,
    },
    {
      name: 'subChoice1',
      label: 'สิ่งที่ต้องการเสริม',
      cardIndex: 1,
    },
    {
      name: 'subChoice2',
      label: 'สิ่งที่ต้องการเสริม (เพิ่มเติม)',
      cardIndex: 1,
    },
    {
      name: 'customCircle',
      label: 'ใส่รูปพื้นหลังดวงจักรราศีของตัวเอง (เพิ่ม 50 บาท)',
      cardIndex: 1,
    },
    {
      name: 'startTimeUse',
      label: 'บริการหาฤกษ์มงคลในการเริ่มใช้วอลเปเปอร์ (เพิ่ม 50 บาท)',
      cardIndex: 1,
    },
    {
      names: ['customerFirstname', 'customerLastname'],
      label: 'ชื่อ - นามสกุล',
      cardIndex: 2,
    },
    {
      type: 'date',
      name: 'dateOfBirth',
      label: 'วัน/เดือน/ปี เกิด',
      cardIndex: 2,
    },
    {
      name: 'timeOfBirth',
      cardIndex: 2,
    },
    {
      name: 'gender',
      cardIndex: 2,
    },
    {
      name: 'genderText',
      cardIndex: 2,
    },
    {
      name: 'disease',
      label: 'โรคประจำตัว',
      cardIndex: 2,
    },
    {
      name: 'telephone',
      cardIndex: 2,
    },
    {
      name: 'email',
      cardIndex: 2,
    },
    {
      name: 'remark',
      cardIndex: 2,
      label: 'หมายเหตุ',
    },
    {
      name: 'divider-1',
      type: 'divider',
      cardIndex: 2,
    },
    {
      template: 'saleChannel',
      cardIndex: 2,
    },
    {
      type: 'image',
      name: 'paySlip',
      cardIndex: 2,
    },
    {
      name: 'divider-2',
      type: 'divider',
      cardIndex: 2,
    },
    {
      name: 'allowNewsletter',
      cardIndex: 2,
      textObject: {
        true: 'ฉันยินดีรับข้อมูลข่าวสาร (Newsletter)',
        false: 'ฉันไม่รับข้อมูลข่าวสาร (Newsletter)',
      },
    },
    {
      template: 'discountCode',
      cardIndex: 3,
    },
  ],
}
